class WishlistCounter extends HTMLElement {
  /** @type {HTMLElement} */
  countElement = this.querySelector('[data-count]');

  /** @type {boolean} */
  loading = false;

  /** @type {object} */
  listDetail = {};

  connectedCallback() {
    // Check if SwymCallbacks exists, if not, create it
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    // Push the addSwymEventListener function to the SwymCallbacks array so it can be called when the Swym Event Layer is initialized
    // window.SwymCallbacks.push(this.addSwymEventListener.bind(this));
    window.SwymCallbacks.push(this.swymInitCallback.bind(this));
  }

  swymInitCallback(swat) {
    // this.swat = swat;
    // Define the event listener function

    // Add listener for the 'addedtowishlist' event to the Swym Event Layer
    swat.evtLayer.addEventListener('sw:addedtowishlist', () => {
      this.fetchListDetails(swat);
    });

    swat.evtLayer.addEventListener('sw:removedfromwishlist', () => {
      this.fetchListDetails(swat);
    });

    setTimeout(() => {
      this.fetchListDetails(swat);
    }, 1000);
  }

  fetchListDetails(swat) {
    const onSuccess = (listDetail) => {
      this.listDetail = listDetail;
      this.render();
    };

    const onError = (error) => {
      console.log(error);
    };

    swat.fetchListDetails({ lid: swymSelectedListId }, onSuccess, onError);
  }

  render() {
    this.countElement.innerHTML = this.listDetail.items.length;
  }
}

customElements.define('wishlist-counter', WishlistCounter);
